import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import Report from '../../../common/components/Report';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/MrdXmlDailyAnalysisSelectors';
import chart from '../components/MrdXmlDailyAnalysisChart';

export class MrdXmlDailyAnalysisContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showChartButton: true,
    };
  }

  render() {
    return (
      <Report
        reportId={ReportDefinitions.MRD_XML_DAILY_ANALYSIS.id}
        columns={this.props.columns}
        isLoading={this.props.isLoading}
        generatedOnDateTime={this.props.generatedDateTime}
        data={this.props.data}
        showChartButton={this.state.showChartButton}
        chartMeta={chart.mrdXmlDailyAnalysis}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
  };
}

MrdXmlDailyAnalysisContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default connect(mapStateToProps)(MrdXmlDailyAnalysisContainer);
